import { Node } from '@tiptap/core'

export const ChartIntro = Node.create({
  name: 'chart_intro',

  group: 'chart_meta',
  content: 'chart_intro_row{6}',  // exactly 6 rows
  isolating: true,
  selectable: false,

  parseHTML() {
    return [{ tag: 'chart-intro' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['chart-intro', { ...HTMLAttributes, class: 'chart_intro_table' }, 0]
  },

  addNodeView() {
    return () => {
      const dom = document.createElement('chart-intro')
      dom.className = 'chart_intro_table'
      dom.tabIndex = -1

      const table = document.createElement('table')
      table.className = 'chart_intro_inner'

      const tbody = document.createElement('tbody')
      table.appendChild(tbody)
      dom.appendChild(table)

      // 🔑 PM will put chart_intro_row nodes (which render as <tr>) inside tbody
      return { dom, contentDOM: tbody }
    }
  },
})



/*

import { Node } from '@tiptap/core'

const INTRO_FIELDS = [
  { label: 'Patient Name', placeholder: '{Patient Name}' },
  { label: 'DOB', placeholder: '{Patient DOB}' },
  { label: 'MRN', placeholder: '{Patient MRN}' },
  { label: 'Visit Date', placeholder: '{Visit Date}' },
  { label: 'Provider', placeholder: '{Provider Name}' },
  { label: 'Visit Format', placeholder: '{Visit Format}' },
]


export const ChartIntro = Node.create({
  name: 'chart_intro',

  group: 'chart_meta',
  atom: true,
  selectable: false,
  isolating: true,

  parseHTML() {
    return [{ tag: 'chart-intro' }]
  },

  renderHTML() {
    return ['chart-intro', { class: 'chart_intro_table' }]
  },

  addNodeView() {
    return () => {
      const dom = document.createElement('chart-intro')
      dom.className = 'chart_intro_table'
      dom.tabIndex = -1

      const table = document.createElement('table')
      table.className = 'chart_intro_inner'

      INTRO_FIELDS.forEach(row => {
        const tr = document.createElement('tr')

        const labelTd = document.createElement('td')
        labelTd.className = 'chart_intro_label'
        labelTd.textContent = row.label

        const valueTd = document.createElement('td')
        valueTd.className = 'chart_intro_value'
        valueTd.textContent = row.placeholder

        tr.appendChild(labelTd)
        tr.appendChild(valueTd)
        table.appendChild(tr)
      })

      dom.appendChild(table)

      return { dom }
    }
  },
})
  */
